import { render } from "./DividendChart.vue?vue&type=template&id=57bcb1ca&scoped=true"
import script from "./DividendChart.vue?vue&type=script&lang=js"
export * from "./DividendChart.vue?vue&type=script&lang=js"

import "./DividendChart.vue?vue&type=style&index=0&id=57bcb1ca&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57bcb1ca"]])

export default __exports__